import { appVariant } from '@util/AppUtils';

export const iosBadge = '/images/logos/iosBadge.svg';
export const playBadge = '/images/logos/googlePlayBadge.png';

export const monash = '/images/logos/monash.png';
/** White keyline version for dark backgrounds. */
export const monashReverse = '/images/logos/monashReverse.svg';
export const baylor = '/images/logos/baylor.png';
export const mindGut = '/images/logos/mindgut-120x100.png';
export const ranzcogAndNams = '/images/logos/ranzcogAndNams.png';
export const nervaMentalHealthLogo = '/images/logos/nervaMentalHealthLogo.png';
export const nervaLogoHeaderWhite = '/images/logos/nervaLogoHeaderWhite.svg';
export const neura = '/images/logos/NeuRA.svg';

export const checkoutVisa = '/images/logos/checkout-visa.svg';
export const checkoutMastercard = '/images/logos/checkout-mastercard.svg';
export const checkoutAmex = '/images/logos/checkout-amex.svg';

export const poweredByStripe = '/images/logos/poweredByStripe.svg';

export const AppLogos = {
  appLogo: appVariant({
    nerva: '/images/logos/nerva.png',
    meno: '/images/logos/evia.png',
    quit: '/images/logos/finito.png',
    pain: '/images/logos/relio.svg',
  }),
  header: appVariant({
    nerva: '/images/logos/nervaLogoHeaderWhite.svg',
    meno: '/images/logos/eviaLogoHeader.svg',
    quit: '/images/logos/finitoLogoHeader.svg',
    pain: '/images/logos/relioLogoHeader.svg',
  }),
  appleTouch: appVariant({
    nerva: '/images/logos/nerva.png',
    meno: '/images/logos/evia.png',
    quit: '/images/logos/finito.png',
    pain: '/images/logos/relioFav.png',
  }),
  favLogo: appVariant({
    nerva: '/images/logos/nervaFav.png',
    meno: '/images/logos/eviaFav.png',
    quit: '/images/logos/finitoFav.png',
    pain: '/images/logos/relioFav.png',
  }),
  brandLogo: appVariant({
    nerva: '/images/logos/nervaLogo.png',
    meno: '/images/logos/eviaLogo.png',
    quit: '/images/logos/finitoLogo.png',
    pain: '/images/logos/relioLogo.svg',
  }),
};
